import { ethers } from 'ethers';

export const formatAmount = (amount: string, decimals: number = 18): string => {
  return ethers.formatUnits(amount, decimals);
};

export const parseAmount = (amount: string, decimals: number = 18): string => {
  return ethers.parseUnits(amount, decimals).toString();
};

// ERC20 ABI for token symbol and decimals
const ERC20_ABI = [
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)'
];

// Cache for token symbols and decimals to avoid repeated calls
const tokenSymbolCache = new Map<string, string>();
const tokenDecimalsCache = new Map<string, number>();

export const getTokenSymbol = async (provider: ethers.Provider, tokenAddress: string): Promise<string> => {
  // Return ETH for zero address
  if (tokenAddress === ethers.ZeroAddress) {
    return 'ETH';
  }

  // Check cache first
  if (tokenSymbolCache.has(tokenAddress)) {
    return tokenSymbolCache.get(tokenAddress)!;
  }

  try {
    // Create ERC20 contract instance
    const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
    
    // Fetch symbol
    const symbol = await tokenContract.symbol();
    
    // Cache the result
    tokenSymbolCache.set(tokenAddress, symbol);
    
    return symbol;
  } catch (error) {
    console.warn(`Failed to fetch symbol for token ${tokenAddress}:`, error);
    // Return generic fallback
    return 'Token';
  }
};

export const getTokenDecimals = async (provider: ethers.Provider, tokenAddress: string): Promise<number> => {
  if (tokenAddress === ethers.ZeroAddress) {
    return 18;
  }
  if (tokenDecimalsCache.has(tokenAddress)) {
    return tokenDecimalsCache.get(tokenAddress)!;
  }
  try {
    const tokenContract = new ethers.Contract(tokenAddress, ERC20_ABI, provider);
    const decimals = await tokenContract.decimals();
    const d = Number(decimals);
    tokenDecimalsCache.set(tokenAddress, d);
    return d;
  } catch (error) {
    console.warn(`Failed to fetch decimals for token ${tokenAddress}:`, error);
    return 18;
  }
};

export const formatTimestamp = (timestamp: string): string => {
  if (timestamp === '0') {
    return 'Not completed yet';
  }
  
  const date = new Date(Number(timestamp) * 1000);
  return date.toLocaleString();
};
